import React from "react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowUp } from "../../assets";
import { useTheme } from "../../context/ThemeProvider";
import SectionDivider from "./SectionDivider";
import SidebarSearch from "./SidebarSearch";
import ScheduledJobsIcon from "./ScheduledJobsIcon";
import ForgeSection from "../Forge/ForgeSidebarSection/ForgeSidebarSection";
import SpectraSidebarSection from "../Spectra/SpectraSidebarSection/SpectraSidebarSection";
import SparkSection from "../Spark/SparkSidebarSection/SparkSidebarSection";
import ROUTES from "../../router/routes";
import UIStore from "../../store/uiStore";


const SidebarContent = ({ closeSidebar }) => {
  const { colorScheme } = useTheme();
  const isDocs = colorScheme === "docs";
  const navigate = useNavigate();
  const location = useLocation();
  const collapsed = UIStore((state) => state.sidebarCollapsed);
  const query = UIStore((state) => state.sidebarQuery);
  const isScheduledJobsActive = location.pathname === ROUTES.SETTINGS.SCHEDULED_JOBS;

  const handleScheduledJobsClick = () => {
    navigate(ROUTES.SETTINGS.SCHEDULED_JOBS);
    if (window.innerWidth < 940) closeSidebar();
  };

  // While searching, force both sections open so results are visible.
  const spectraOpen = !!query || !collapsed.spectra;
  const sparkOpen = !!query || !collapsed.spark;

  return (
    <div className="h-full flex flex-col">
      <SidebarSearch />

      <div className="flex flex-col flex-shrink-0">
        <SectionDivider className="mt-3 mx-3" />
        <ForgeSection />
        <div className="px-3 pb-[10px]">
          <motion.button
            type="button"
            onClick={handleScheduledJobsClick}
            initial="rest"
            animate="rest"
            whileHover="hover"
            className={`group flex w-full items-center gap-[7px] rounded-md py-[7px] text-sm font-semibold ${
              isScheduledJobsActive
                ? isDocs ? "bg-fill-primary/10 text-ink-primary" : "bg-fill-sidebar-surface text-ink-ink-deep dark:bg-fill-navigation-active dark:text-ink-white"
                : isDocs ? "text-ink-gray-500" : "text-ink-control-border dark:text-ink-white"
            }`}
            aria-label="Scheduled Jobs"
            aria-current={isScheduledJobsActive ? "page" : undefined}
          >
            <ScheduledJobsIcon className="h-5 w-[18px] flex-shrink-0" />
            <motion.span
              className={`transition-colors duration-300 ease-out ${isDocs ? "" : "group-hover:text-ink-ink-deep dark:group-hover:text-ink-white"}`}
            >
              Scheduled Jobs
            </motion.span>
            <motion.span
              className="ml-2 text-ink-ink-deep dark:text-ink-white"
              variants={{
                rest: { opacity: 0, x: -5 },
                hover: { opacity: 1, x: 0 },
              }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            >
              <ArrowUp className="h-4 w-[11px] rotate-90 fill-ink-ink-deep dark:fill-ink-white" />
            </motion.span>
          </motion.button>
        </div>
      </div>

      <div className={`flex flex-col min-h-0 ${spectraOpen ? "flex-1" : "flex-shrink-0"}`}>
        <SectionDivider className="mt-3 mx-3 flex-shrink-0" />
        <SpectraSidebarSection />
      </div>

      <div className={`flex flex-col min-h-0 mb-3 ${sparkOpen ? "flex-1" : "flex-shrink-0"}`}>
        <SectionDivider className="mt-3 mx-3 flex-shrink-0" />
        <SparkSection />
      </div>
    </div>
  );
};

export default SidebarContent;
